import { CHECK_JOB_STATUS, JOB_STATUS_SUCCESS, JOB_STATUS_PENDING } from "../types"

const initialState = {
	job: [],
}

// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case JOB_STATUS_SUCCESS:
			let jobArraySuccess = state.job
			jobArraySuccess.push(action.payload)
			return {
				job: jobArraySuccess,
			}

		case JOB_STATUS_PENDING:
			let jobArrayPending = state.job
			jobArrayPending.push(action.payload)
			return {
				job: jobArrayPending,
			}
		default:
			return state
	}
}
